export default "__VITE_ASSET__DJMrReoi__"